<template>
  <button @click.prevent="$emit('input', item.id)" :class="{ onfocus: value === item.id }" class="relative">
    <span class="
                            iconfont
                            icon-xuanzhong
                            absolute
                            -mt-5px
                            ml-7px
                            text-main
                            hidden
                            show
                            transform
                            scale-200
                          "></span>
    <slot>
      <div class="tabb">
        <div class="direction">
          {{ item.deparea.name }}-{{ item.desarea.name }}
        </div>
        <div class="id">{{ item.number }}</div>
        <div class="time">
          {{ start_time.format("HH:mm") }}-{{ end_time.format("HH:mm") }}
        </div>
        <div class="date">{{ start_time.format("MM-DD") }}</div>
      </div>
    </slot>
  </button>
</template>

<script>
import dayjs from "@/API/util/dayjs.js";
import { watchEffect, ref } from "@vue/composition-api";
export default {
  props: {
    item: Object,
    value: [Number, String],
  },
  setup(props) {

    if (props?.item?.deptime && props?.item?.arrtime) {
      const start_time = dayjs.unix(props.item.deptime.timestamp);
      const end_time = dayjs.unix(props.item.arrtime.timestamp);
      return { start_time, end_time };
    }

  },
};
</script>

<style scoped lang="scss">
button {
  background: #fff;
  border-radius: 0px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(221, 225, 227, var(--tw-ring-opacity));
}
.onfocus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(21, 186, 99, var(--tw-ring-opacity));
}
.onfocus .show {
  display: block;
}
.tabb {
  display: -ms-grid;
  display: grid;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  line-height: 1;
  padding: 1rem;
  -webkit-column-gap: 2rem;
  -moz-column-gap: 2rem;
  grid-column-gap: 2rem;
  column-gap: 2rem;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(2, auto);
  grid-template-areas: "direction id date"
      "direction time date";
}
.id {
  grid-area: id;
}
.direction {
  grid-area: direction;
}
.time {
  grid-area: time;
}
.date {
  grid-area: date;
}
</style>
